import type { QueryOptions } from '@tanstack/react-query';

import { http, internalHttp } from '@/api/instance';

export const userAPI = {
  permissions: () =>
    http.get<ListResultsPageSize<PermissionKey>>('/api/info/users/permissions').then(({ data }) => data),
  saleAgency: () =>
    internalHttp.get<DataResponse<{ sale_agency_id: number }>>('/api/info/users/sale_agency').then(({ data }) => data),

  create: (data: UserFormPayload) => http.post<DataResponse<User>>(`/api/add/users`, { data }),
  update: (id: number | string, data: Partial<UserFormPayload>) => http.put<unknown>(`/api/edit/users/${id}`, { data }),
  delete: (id: number | string) => http.delete<unknown>(`/api/delete/users/${id}`),
};

export const userQuery = {
  permissions: () =>
    ({
      queryKey: ['GetUserPermissions'] as const,
      queryFn: () => userAPI.permissions(),
    }) as const satisfies QueryOptions,
  saleAgency: () =>
    ({
      queryKey: ['GetUserSaleAgency'] as const,
      queryFn: () => userAPI.saleAgency(),
    }) as const satisfies QueryOptions,
};
